if (!customElements.get('about-accordion')) {
  customElements.define(
    'about-accordion',
    class AboutAccordion extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-accordion-item]'));
        this.onTriggerClick = this.onTriggerClick.bind(this);
        this.setupEventListeners();
        this.openItem(this.items[0], false);
      }

      disconnectedCallback() {
        for (const item of this.items) {
          const trigger = item.querySelector('[data-accordion-trigger]');
          trigger?.removeEventListener('click', this.onTriggerClick);
        }
      }

      setupEventListeners() {
        for (const item of this.items) {
          const trigger = item.querySelector('[data-accordion-trigger]');
          trigger?.addEventListener('click', this.onTriggerClick);
        }
      }

      onTriggerClick(event) {
        const trigger = event.currentTarget;
        const item = trigger.closest('[data-accordion-item]');
        if (!item) return;

        const isOpen = item.classList.contains('is-open');
        this.closeAll();
        if (!isOpen) {
          this.openItem(item);
        }
      }

      closeAll() {
        for (const item of this.items) {
          item.classList.remove('is-open');
          const trigger = item.querySelector('[data-accordion-trigger]');
          const panel = item.querySelector('[data-accordion-panel]');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
          if (panel) panel.setAttribute('aria-hidden', 'true');
        }
      }

      openItem(item, focusTrigger = false) {
        if (!item) return;

        item.classList.add('is-open');
        const trigger = item.querySelector('[data-accordion-trigger]');
        const panel = item.querySelector('[data-accordion-panel]');
        if (trigger) {
          trigger.setAttribute('aria-expanded', 'true');
          if (focusTrigger) trigger.focus();
        }
        if (panel) panel.setAttribute('aria-hidden', 'false');
      }
    }
  );
}
